module.exports = __webpack_public_path__ + "um.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/um.svg
// module id = 865
// module chunks = 0